export const STEPS = {
  START: 'start',
  BASIC_INFO: 'basic-info',
  OTP_VALIDATION: 'otp-validation',
  EXISTS_OTP_VALIDATION: 'exists-otp-validation',
  PASSWORD: 'password',
  SUCCESS_BASIC: 'success-basic',
  SUCCESS_BASIC_LINKED: 'success-basic-linked',
  IDENTITY_VALIDATION: 'identity-validation',
  IDENTITY_RESUME: 'identity-resume',
  ADDRESS: 'address',
  SUCCESS_COMPLETE: 'success-complete',
};

export const SUCCESS_TYPES = {
  BASIC: 'basic',
  BASIC_LINKED: 'basic-linked',
  COMPLETE: 'complete',
};

export const SIGNUP_OTP_CHANNEL = {
  SMS: 'SMS',
  WHATSAPP: 'WHATSAPP',
};

/** Errores de /signup/complete que se resuelven pidiendo un OTP nuevo. */
export const COMPLETE_OTP_RETRY_ERRORS = [
  'OTP_PHONE_EXPIRED',
  'OTP_EMAIL_EXPIRED',
  'OTP_PHONE_NOT_MATCH',
  'OTP_EMAIL_NOT_MATCH',
  'OTP_NOT_MATCH',
];

export function isCompleteOtpRetryError(errorCode) {
  return COMPLETE_OTP_RETRY_ERRORS.includes(errorCode);
}

/** Errores de /signup/otp/verify que informan intentos restantes. */
export const SIGNUP_OTP_ATTEMPT_ERRORS = [
  'OTP_PHONE_NOT_MATCH',
  'OTP_EMAIL_NOT_MATCH',
];

/**
 * Campo que hay que vaciar para capturar un código nuevo.
 * @param {string} errorCode
 * @returns {'phone'|'email'|null}
 */
export function getSignupOtpFieldToReset(errorCode) {
  if (errorCode === 'OTP_PHONE_EXPIRED' || errorCode === 'OTP_PHONE_LOCKED') {
    return 'phone';
  }
  if (errorCode === 'OTP_EMAIL_EXPIRED' || errorCode === 'OTP_EMAIL_LOCKED') {
    return 'email';
  }
  return null;
}

/** El código bloqueado no se puede volver a validar: hay que reenviar. */
export function isSignupOtpLockedError(errorCode) {
  return errorCode === 'OTP_PHONE_LOCKED' || errorCode === 'OTP_EMAIL_LOCKED';
}

/**
 * Texto de error de /signup/otp/verify.
 * remainingAttempts solo se muestra en los NOT_MATCH de celular y correo.
 * @param {object} error
 * @param {object} messages
 * @returns {string}
 */
export function mapSignupOtpVerifyMessage(error, messages = {}) {
  const code = error?.data?.error;
  const base = messages[code] || code || '';
  const rawAttempts = error?.data?.remainingAttempts;
  const showsAttempts = SIGNUP_OTP_ATTEMPT_ERRORS.includes(code)
    && rawAttempts != null
    && rawAttempts !== '';
  if (!showsAttempts) {
    return base;
  }
  const remaining = Number(rawAttempts);
  if (!Number.isInteger(remaining) || remaining < 0) {
    return base;
  }
  const attemptsLabel = (messages.remainingAttempts || 'Intentos restantes: {remaining}.')
    .replace('{remaining}', String(remaining));
  return `${base}. ${attemptsLabel}`.trim();
}

const NEW_CLIENT_STEP_INDEX = {
  [STEPS.START]: 1,
  [STEPS.BASIC_INFO]: 2,
  [STEPS.OTP_VALIDATION]: 3,
  [STEPS.IDENTITY_VALIDATION]: 4,
  [STEPS.IDENTITY_RESUME]: 5,
  [STEPS.ADDRESS]: 6,
  [STEPS.PASSWORD]: 7,
};

const EXISTING_CLIENT_STEP_INDEX = {
  [STEPS.START]: 1,
  [STEPS.EXISTS_OTP_VALIDATION]: 2,
  [STEPS.PASSWORD]: 3,
};

export const NEW_CLIENT_STEP_TOTAL = 7;
export const EXISTING_CLIENT_STEP_TOTAL = 3;

/**
 * Progreso del header. El alta nueva es un solo recorrido;
 * el cliente existente conserva su escala corta.
 */
export function getRegistrationProgress(step, existingClient = false) {
  if (existingClient) {
    return {
      step: EXISTING_CLIENT_STEP_INDEX[step] || 1,
      total: EXISTING_CLIENT_STEP_TOTAL,
    };
  }
  return {
    step: NEW_CLIENT_STEP_INDEX[step] || 1,
    total: NEW_CLIENT_STEP_TOTAL,
  };
}

export const CLIENT_EXISTS_TYPES = {
  CLIENT_ID: 'CLIENT_ID',
  INE: 'INE',
};

export const GENDERS = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
};

export const ID_MISSION_VARS = {
  APPROVED: 'Approved',
  OK: 'OK',
  CUSTOMER_ONBOARDED: 'Customer Onboarded',
  DUPLICATE_CUSTOMER: 'Duplicate Customer',
};

/** Tipo de documento ID Mission: VID (INE/IFE) usa M/H; PP (pasaporte) usa M/F */
export const ID_TYPE = {
  VID: 'VID',
  PP: 'PP',
};

export const COUNTRIES = {
  AD: 'Andorra',
  AR: 'Argentina',
  BO: 'Bolivia',
  CL: 'Chile',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  EC: 'Ecuador',
  SV: 'El Salvador',
  ES: 'España',
  GQ: 'Guinea Ecuatorial',
  GT: 'Guatemala',
  HN: 'Honduras',
  MX: 'México',
  NI: 'Nicaragua',
  DO: 'República Dominicana',
  PA: 'Panamá',
  PE: 'Perú',
  PY: 'Paraguay',
  UY: 'Uruguay',
  VE: 'Venezuela',
};
